export const yesNoOptions = [
    { label: 'No', id: 0 },
    { label: 'Yes', id: 1 },
]

export const vectorGroupOptions = [
    { label: 'YNyn0', id: 'YNyn0' },
    { label: 'YNd1', id: 'YNd1' },
    { label: 'YNd11', id: 'YNd11' },
    { label: 'Dyn11', id: 'Dyn11' },
    { label: 'Dyn1', id: 'Dyn1' },
    { label: 'Dd0', id: 'Dd0' },
    { label: 'YNyn0yn0', id: 'YNyn0yn0' },
    { label: 'YNyn0d11', id: 'YNyn0d11' },
    { label: 'YNyn0d1', id: 'YNyn0d1' },
    { label: 'YNd11d11', id: 'YNd11d11' },
    { label: 'Dyn11yn11', id: 'Dyn11yn11' },
    { label: 'Dyn1yn1', id: 'Dyn1yn1' },
    { label: 'YNa0d11', id: 'YNa0d11' },
    { label: 'YNa0d1', id: 'YNa0d1' },
    { label: 'YNa0', id: 'YNa0' },
]

export const vectorWindingOptions = [
    { label: 'YNyn0', id: 'YNyn0' },
    { label: 'YNd1', id: 'YNd1' },
    { label: 'YNd11', id: 'YNd11' },
    { label: 'Dyn11', id: 'Dyn11' },
    { label: 'Dyn1', id: 'Dyn1' },
    { label: 'Dyn5', id: 'Dyn5' },
    { label: 'Dd0', id: 'Dd0' },
    { label: 'YNa0', id: 'YNa0' },
]

export const phasesOptions = [
    { label: 'Single', id: 1 },
    // { label: 'Two', id: 2 },
    { label: 'Three', id: 3 },
]

export const locationOfTestingOptions = [
    { label: 'Transformer Testlab LPT, Indo Tech Transformers Limited, Kanchipuram - 631561.', id: 1 },
    { label: 'Transformer Testlab DT, Indo Tech Transformers Limited, Kanchipuram - 631561.', id: 2 },
]

export const productNameOptions = [
    { label: 'Oil Immeresed Power Transformer', id: 1 },
    { label: 'Oil Immeresed Distribution Transformer', id: 2 },
    { label: 'Oil Immeresed Auto Transformer', id: 3 },
    { label: 'Dry Type Transformer', id: 4 },
]

export const conditionOfItemOptions = [
    { label: 'New & Good Condition', id: 1 },
    { label: 'Repair & Good Condition', id: 2 },
]

export const transformerTypeOptions = [
    { label: 'Auto Transformer', id: 1 },
    { label: 'Power Transformer', id: 2 },
    { label: 'Distribution Transformer', id: 3 },
    { label: 'Dry Type Transformer', id: 4 },
    { label: 'Generator Transformer', id: 5 },
]

export const ratingSelectionOptions = [
    { label: 'Single Rating', id: 1 },
    { label: 'Two Rating', id: 2 },
    { label: 'Three Rating', id: 3 },
]

export const windingConnectionOptions = [
    { label: 'Star', id: 1, value: 1 },
    { label: 'Delta', id: 2, value: 2 },
]

export const windingResistancUnitOptions = [
    { label: 'Ohms', id: 1, value: 1 },
    { label: 'milli Ohms', id: 2, value: 2 },
]

export const windingResistancCombinationOptions = [
    { label: 'Line to Line', id: 'll', value: 'll' },
    { label: 'Line to Neutral', id: 'ln', value: 'ln' },
]

export const windingSortMarkingOptions = [
    { label: 'H', id: 1 },
    { label: 'I', id: 2 },
    { label: 'M', id: 3 },
    { label: 'L', id: 4 },
    { label: 'T', id: 5 },
    { label: 'L1', id: 6 },
    { label: 'L2', id: 7 },
    { label: 'N', id: 8 },
]

export const windingMarkingOptions = [
    { label: 'HV', id: 1 },
    { label: 'IV', id: 2 },
    { label: 'MV', id: 3 },
    { label: 'LV', id: 4 },
    { label: 'TV', id: 5 },
    { label: 'LV1', id: 6 },
    { label: 'LV2', id: 7 },
    { label: 'N', id: 8 },
]

export const phaseMarkingOptions = [
    { label: 'UVW', id: 1 },
    { label: 'ABC', id: 2 },
    { label: 'RYB', id: 3 },
]

export const windingTypeOptions = [
    { label: '2 Wdg Transformer', id: 1 },
    { label: '3 Wdg Transformer', id: 2 },
    { label: '2 Wdg Auto Transformer', id: 3 },
    { label: '3 Wdg Auto Transformer', id: 4 },
]

export const frequencyOptions = [
    { label: '50', id: 1 },
    { label: '60', id: 2 },
]

export const tapVariationOptions = [
    { label: 'HV', id: 1 },
    { label: 'IV', id: 2 },
    { label: 'MV', id: 3 },
    { label: 'LV', id: 4 },
    { label: 'TV', id: 5 },
    { label: 'LV1', id: 6 },
    { label: 'LV2', id: 7 },
    { label: 'NA', id: 8 },
]

export const testTypeOptions = [
    { label: 'Stage', id: 0 },
    { label: 'Testing', id: 1 },
]

export const transformerTestOptions = [
    { label: 'Internal', id: 0 },
    { label: 'Customer', id: 1 },
]

export const transformerTestTypeOptions = [
    { label: 'Stage Testing (TL)', id: 0, type: 0, new_id: 2 },
    { label: 'Final Testing (TL)', id: 1, type: 0, new_id: 4 },
    { label: 'Stage Testing (TL)', id: 2, type: 1, new_id: 0 },
    { label: 'Stage (QA)', id: 3, type: 1 },
    { label: 'Final Testing (TL)', id: 4, type: 1, new_id: 1 },
    { label: 'Final (QA)', id: 5, type: 1 },
]

export const inspectorTypesOptions = [
    { label: 'Third Party Inspector', id: 0 },
    { label: 'Customer Representative', id: 1 },
]

export const inputDataTypeOptions = [
    { label: 'String', id: 0 },
    { label: 'Number', id: 1 },
    { label: 'Select', id: 2 },
    { label: 'MultiSelect', id: 3 },
    { label: 'Date (DD/MM/YYYY)', id: 4 },
]

export const dataTypeOptions = [
    { label: 'String', id: 0 },
    { label: 'Number', id: 1 },
    { label: 'Image', id: 2 },
    { label: 'Time (H:M A)', id: 3 },
    { label: 'Time (H:M:S)', id: 4 },
    { label: 'Date (DD/MM/YYYY)', id: 5 },
]

export const digitOptions = [
    { label: '0', id: 0 },
    { label: '1', id: 1 },
    { label: '2', id: 2 },
    { label: '3', id: 3 },
    { label: '4', id: 4 },
    { label: '5', id: 5 },
]

export const arrayOptions = [
    { label: 'Single Value', id: 0 },
    { label: 'Array', id: 1 },
    { label: 'Nested Array', id: 2 },
]

export const parameterTypeOptions = [
    { label: 'Single Value', id: 1 },
    { label: 'Matrix', id: 2 },
]

export const viewTypeOptions = [
    { label: 'Parameter', id: 1 },
    { label: 'Table', id: 2 },
    { label: 'Image', id: 3 },
    { label: 'Label', id: 4 },
    { label: 'Graph', id: 5 },
]

export const rowTypeOptions = [
    { label: 'Fixed', id: 0 },
    { label: 'Variable Ascending', id: 1 },
    { label: 'Variable Descending', id: 2 },
]

export const nablNonCompliantOptions = [
    { label: 'NABL Compliant', id: 0 },
    { label: 'NABL Non Compliant', id: 1 },
]

export const gridOptions = [
    { label: '1', id: 1 },
    { label: '2', id: 2 },
    { label: '3', id: 3 },
    { label: '4', id: 4 },
    { label: '5', id: 5 },
    { label: '6', id: 6 },
    { label: '7', id: 7 },
    { label: '8', id: 8 },
    { label: '9', id: 9 },
    { label: '10', id: 10 },
    { label: '11', id: 11 },
    { label: '12', id: 12 },
]

export const rowsOptions = [
    { label: '5', id: 5 },
    { label: '6', id: 6 },
    { label: '7', id: 7 },
    { label: '8', id: 8 },
    { label: '9', id: 9 },
    { label: '10', id: 10 },
    { label: '11', id: 11 },
    { label: '12', id: 12 },
    { label: '13', id: 13 },
    { label: '14', id: 14 },
    { label: '15', id: 15 },
    { label: '16', id: 16 },
    { label: '17', id: 17 },
    { label: '18', id: 18 },
    { label: '19', id: 19 },
    { label: '20', id: 20 },
    { label: '21', id: 21 },
    { label: '22', id: 22 },
    { label: '23', id: 23 },
    { label: '24', id: 24 },
    { label: '25', id: 25 },
    { label: '26', id: 26 },
    { label: '27', id: 27 },
    { label: '28', id: 28 },
    { label: '29', id: 29 },
    { label: '30', id: 30 },
    { label: '31', id: 31 },
    { label: '32', id: 32 },
    { label: '33', id: 33 },
    { label: '34', id: 34 },
    { label: '35', id: 35 },
]

export const fontSizeOptions = [
    { label: '6', id: 6 },
    { label: '7', id: 7 },
    { label: '8', id: 8 },
    { label: '9', id: 9 },
    { label: '10', id: 10 },
    { label: '11', id: 11 },
]

export const textAlignOptions = [
    { label: 'Left', id: 'left' },
    { label: 'Center', id: 'center' },
    { label: 'Right', id: 'right' },
]

export const diagramsTypeOptions = [
    { label: 'Verification of Vector group and check of phase displacement', id: 0 },
    { label: 'Check of polarity and phase relation test', id: 1 },
    { label: 'Line terminal AC withstand voltage test (LTAC Test)', id: 2 },
    { label: 'Induced voltage test with PD measurement (IVPD Test)', id: 3 },
    { label: 'Full wave lightning impulse test for the line terminals (LI)', id: 4 },
    { label: 'Chopped wave lightning impulse test for the line terminals (LIC)', id: 5 },
    { label: 'Lightning impulse test for the neutral terminals (LIN)', id: 6 },
    { label: 'Switching impulse test for the line terminal (SI)', id: 7 },
    { label: 'Determination of sound level Test', id: 8 },
]

export const formulaOperators = [
    1,
    2,
    3,
    '+',
    '-',
    '*',
    '/',
    4,
    5,
    6,
    '^',
    '(',
    ')',
    '?',
    7,
    8,
    9,
    '<',
    '>',
    '>=',
    '<=',
    '.',
    0,
    ':',
    '==',
    '!=',
]

export const transformerDefaultData = [
    { id: 'work_order_no', name: 'work_order_no', data_type: 0, value: 'IT-1111-1' },
    { id: 'order_no', name: 'order_no', data_type: 1, value: 1111 },
    { id: 'unit_no', name: 'unit_no', data_type: 1, value: 1 },
    { id: 'serial_number', name: 'serial_number', data_type: 0, value: 'ITK-11111' },
    { id: 'location_of_testing', name: 'location_of_testing', data_type: 1, value: 1 },
    { id: 'product_name', name: 'product_name', data_type: 1, value: 1 },
    { id: 'condition_of_item', name: 'condition_of_item', data_type: 1, value: 1 },
    { id: 'transformer_type', name: 'transformer_type', data_type: 1, value: 1 },
    { id: 'rating_selection', name: 'rating_selection', data_type: 1, value: 1 },
    { id: 'place_of_inspection', name: 'place_of_inspection', data_type: 0, value: 'Indotech Transformers limited, Kanchipuram' },
    { id: 'wdg_1_voltage_rating', name: 'wdg_1_voltage_rating', data_type: 1, value: 220 },
    { id: 'wdg_2_voltage_rating', name: 'wdg_2_voltage_rating', data_type: 1, value: 33 },
    { id: 'wdg_3_voltage_rating', name: 'wdg_3_voltage_rating', data_type: 1, value: 33 },
    { id: 'vector_group', name: 'vector_group', data_type: 0, value: 'YNyn0yn0' },
    { id: 'winding_1_2_vector', name: 'winding_1_2_vector', data_type: 0, value: 'YNyn0' },
    { id: 'winding_1_3_vector', name: 'winding_1_3_vector', data_type: 0, value: 'YNyn0' },
    { id: 'winding_2_3_vector', name: 'winding_2_3_vector', data_type: 0, value: 'YNyn0' },
    { id: 'wdg_1_connection_type', name: 'wdg_1_connection_type', data_type: 1, value: 1 },
    { id: 'wdg_2_connection_type', name: 'wdg_2_connection_type', data_type: 1, value: 1 },
    { id: 'wdg_3_connection_type', name: 'wdg_3_connection_type', data_type: 1, value: 1 },
    { id: 'wdg_1_resistanc_unit', name: 'wdg_1_resistanc_unit', data_type: 1, value: 1 },
    { id: 'wdg_2_resistanc_unit', name: 'wdg_2_resistanc_unit', data_type: 1, value: 1 },
    { id: 'wdg_3_resistanc_unit', name: 'wdg_3_resistanc_unit', data_type: 1, value: 1 },
    { id: 'wdg_1_resistanc_combination', name: 'wdg_1_resistanc_combination', data_type: 2, value: 1 },
    { id: 'wdg_2_resistanc_combination', name: 'wdg_2_resistanc_combination', data_type: 2, value: 1 },
    { id: 'wdg_3_resistanc_combination', name: 'wdg_3_resistanc_combination', data_type: 2, value: 1 },
    { id: 'wdg_1_sort_marking', name: 'wdg_1_sort_marking', data_type: 1, value: 1 },
    { id: 'wdg_2_sort_marking', name: 'wdg_2_sort_marking', data_type: 1, value: 1 },
    { id: 'wdg_3_sort_marking', name: 'wdg_3_sort_marking', data_type: 1, value: 1 },
    { id: 'neutral_sort_marking', name: 'neutral_sort_marking', data_type: 1, value: 1 },
    { id: 'wdg_1_marking', name: 'wdg_1_marking', data_type: 1, value: 1 },
    { id: 'wdg_2_marking', name: 'wdg_2_marking', data_type: 1, value: 1 },
    { id: 'wdg_3_marking', name: 'wdg_3_marking', data_type: 1, value: 1 },
    { id: 'neutral_marking', name: 'neutral_marking', data_type: 1, value: 1 },
    { id: 'ref_temp_corrected', name: 'ref_temp_corrected', data_type: 1, value: 75 },
    { id: 'wdg_co_efficient_constant', name: 'wdg_co_efficient_constant', data_type: 1, value: 235 },
    { id: 'phase_marking', name: 'phase_marking', data_type: 1, value: 1 },
    { id: 'wdg_type', name: 'wdg_type', data_type: 1, value: 1 },
    { id: 'rated_frequency', name: 'rated_frequency', data_type: 1, value: 1 },
    { id: 'wdg_1_first_rating', name: 'wdg_1_first_rating', data_type: 1, value: 126 },
    { id: 'wdg_1_second_rating', name: 'wdg_1_second_rating', data_type: 1, value: 168 },
    { id: 'wdg_1_third_rating', name: 'wdg_1_third_rating', data_type: 1, value: 210 },
    { id: 'wdg_2_first_rating', name: 'wdg_2_first_rating', data_type: 1, value: 63 },
    { id: 'wdg_2_second_rating', name: 'wdg_2_second_rating', data_type: 1, value: 84 },
    { id: 'wdg_2_third_rating', name: 'wdg_2_third_rating', data_type: 1, value: 105 },
    { id: 'wdg_3_first_rating', name: 'wdg_3_first_rating', data_type: 1, value: 63 },
    { id: 'wdg_3_second_rating', name: 'wdg_3_second_rating', data_type: 1, value: 84 },
    { id: 'wdg_3_third_rating', name: 'wdg_3_third_rating', data_type: 1, value: 105 },
    { id: 'no_of_phases', name: 'no_of_phases', data_type: 1, value: 1 },
    { id: 'wdg_1_phase_1_marking', name: 'wdg_1_phase_1_marking', data_type: 0, value: '1.1' },
    { id: 'wdg_1_phase_2_marking', name: 'wdg_1_phase_2_marking', data_type: 0, value: '1.2' },
    { id: 'wdg_1_neutral_marking', name: 'wdg_1_neutral_marking', data_type: 0, value: 'N' },
    { id: 'wdg_2_phase_1_marking', name: 'wdg_2_phase_1_marking', data_type: 0, value: '2.1' },
    { id: 'wdg_2_phase_2_marking', name: 'wdg_2_phase_2_marking', data_type: 0, value: '2.2' },
    { id: 'wdg_2_neutral_marking', name: 'wdg_2_neutral_marking', data_type: 0, value: 'N' },
    { id: 'wdg_3_phase_1_marking', name: 'wdg_3_phase_1_marking', data_type: 0, value: '3.1' },
    { id: 'wdg_3_phase_2_marking', name: 'wdg_3_phase_2_marking', data_type: 0, value: '3.2' },
    { id: 'wdg_3_neutral_marking', name: 'wdg_3_neutral_marking', data_type: 0, value: 'N' },
    { id: 'wdg_1_li_line', name: 'wdg_1_li_line', data_type: 1, value: 1050 },
    { id: 'wdg_1_av_line', name: 'wdg_1_av_line', data_type: 1, value: 38 },
    { id: 'wdg_1_iov_line', name: 'wdg_1_iov_line', data_type: 1, value: 460 },
    { id: 'wdg_1_li_neutral', name: 'wdg_1_li_neutral', data_type: 1, value: 95 },
    { id: 'wdg_1_av_neutral', name: 'wdg_1_av_neutral', data_type: 1, value: 38 },
    { id: 'wdg_2_li_line', name: 'wdg_2_li_line', data_type: 1, value: 170 },
    { id: 'wdg_2_av_line', name: 'wdg_2_av_line', data_type: 1, value: 70 },
    { id: 'wdg_2_iov_line', name: 'wdg_2_iov_line', data_type: 1, value: 66 },
    { id: 'wdg_2_li_neutral', name: 'wdg_2_li_neutral', data_type: 1, value: 170 },
    { id: 'wdg_2_av_neutral', name: 'wdg_2_av_neutral', data_type: 1, value: 70 },
    { id: 'wdg_3_li_line', name: 'wdg_3_li_line', data_type: 1, value: 170 },
    { id: 'wdg_3_av_line', name: 'wdg_3_av_line', data_type: 1, value: 70 },
    { id: 'wdg_3_iov_line', name: 'wdg_3_iov_line', data_type: 1, value: 66 },
    { id: 'wdg_3_li_neutral', name: 'wdg_3_li_neutral', data_type: 1, value: 170 },
    { id: 'wdg_3_av_neutral', name: 'wdg_3_av_neutral', data_type: 1, value: 70 },
    { id: 'wdg_1_li_si', name: 'wdg_1_li_si', data_type: 1, value: 850 },
    { id: 'wdg_2_li_si', name: 'wdg_2_li_si', data_type: 1, value: 850 },
    { id: 'wdg_3_li_si', name: 'wdg_3_li_si', data_type: 1, value: 850 },
    { id: 'rating_oil_temp', name: 'rating_oil_temp', data_type: 1, value: 50 },
    { id: 'wdg_1_rating_temp', name: 'wdg_1_rating_temp', data_type: 1, value: 55 },
    { id: 'wdg_2_rating_temp', name: 'wdg_2_rating_temp', data_type: 1, value: 55 },
    { id: 'wdg_3_rating_temp', name: 'wdg_3_rating_temp', data_type: 1, value: 55 },
    { id: 'wdg_1_voltage_varation', name: 'wdg_1_voltage_varation', data_type: 1, value: 1 },
    { id: 'wdg_1_pos_tap', name: 'wdg_1_pos_tap', data_type: 1, value: 10 },
    { id: 'wdg_1_neg_tap', name: 'wdg_1_neg_tap', data_type: 1, value: -10 },
    { id: 'wdg_1_tap_step', name: 'wdg_1_tap_step', data_type: 1, value: 1.25 },
    { id: 'wdg_1_tap_varation', name: 'wdg_1_tap_varation', data_type: 1, value: 1 },
    { id: 'wdg_2_voltage_varation', name: 'wdg_2_voltage_varation', data_type: 1, value: 1 },
    { id: 'wdg_2_pos_tap', name: 'wdg_2_pos_tap', data_type: 1, value: 10 },
    { id: 'wdg_2_neg_tap', name: 'wdg_2_neg_tap', data_type: 1, value: -10 },
    { id: 'wdg_2_tap_step', name: 'wdg_2_tap_step', data_type: 1, value: 1.25 },
    { id: 'wdg_2_tap_varation', name: 'wdg_2_tap_varation', data_type: 1, value: 1 },
    { id: 'wdg_3_voltage_varation', name: 'wdg_3_voltage_varation', data_type: 1, value: 1 },
    { id: 'wdg_3_pos_tap', name: 'wdg_3_pos_tap', data_type: 1, value: 10 },
    { id: 'wdg_3_neg_tap', name: 'wdg_3_neg_tap', data_type: 1, value: -10 },
    { id: 'wdg_3_tap_step', name: 'wdg_3_tap_step', data_type: 1, value: 1.25 },
    { id: 'wdg_3_tap_varation', name: 'wdg_3_tap_varation', data_type: 1, value: 1 },
    { id: 'mva_rating_wdg_1', name: 'mva_rating_wdg_1', data_type: 0, value: '126.0 / 63.0 / 63.0 MVA' },
    { id: 'voltage_rating', name: 'voltage_rating', data_type: 0, value: '220.00 / 33.00 / 33.00 kV' },
    { id: 'cooling_type_1_name', name: 'cooling_type_1_name', data_type: 0, value: '`OFAF`' },
    { id: 'cooling_type_2_name', name: 'cooling_type_2_name', data_type: 0, value: '`OFAF`' },
    { id: 'cooling_type_3_name', name: 'cooling_type_3_name', data_type: 0, value: '`OFAF`' },
    { id: 'cooling_type_1_oil_rise', name: 'cooling_type_1_oil_rise', data_type: 1, value: 0.8 },
    { id: 'cooling_type_2_oil_rise', name: 'cooling_type_2_oil_rise', data_type: 1, value: 0.8 },
    { id: 'cooling_type_3_oil_rise', name: 'cooling_type_3_oil_rise', data_type: 1, value: 0.8 },
    { id: 'wdg_1_resistanc_unit_show', name: 'wdg_1_resistanc_unit_show', data_type: 0, value: 'Ώ' },
    { id: 'wdg_2_resistanc_unit_show', name: 'wdg_2_resistanc_unit_show', data_type: 0, value: 'Ώ' },
    { id: 'wdg_3_resistanc_unit_show', name: 'wdg_3_resistanc_unit_show', data_type: 0, value: 'Ώ' },
    // Detail
    { id: 'temp_correcte_constant', name: 'temp_correcte_constant', data_type: 1, value: 310 },
    { id: 'phase_1', name: 'phase_1', data_type: 0, value: 'A' },
    { id: 'phase_2', name: 'phase_2', data_type: 0, value: 'B' },
    { id: 'phase_3', name: 'phase_3', data_type: 0, value: 'C' },
    { id: 'nutral_1', name: 'nutral_1', data_type: 0, value: '1N' },
    { id: 'nutral_2', name: 'nutral_2', data_type: 0, value: '2N' },
    { id: 'nutral_3', name: 'nutral_3', data_type: 0, value: '3N' },
    { id: 'terminal_phase_1', name: 'terminal_phase_1', data_type: 2, value: '1A' },
    { id: 'terminal_phase_2', name: 'terminal_phase_2', data_type: 2, value: '1B' },
    { id: 'terminal_phase_3', name: 'terminal_phase_3', data_type: 2, value: '1C' },
    { id: 'terminal_impulse', name: 'terminal_impulse', data_type: 0, value: 'HV, LV1 & LV2' },
    { id: 'terminal_phase_1_li_lic', name: 'terminal_phase_1_li_lic', data_type: 2, value: '1A' },
    { id: 'terminal_phase_2_li_lic', name: 'terminal_phase_2_li_lic', data_type: 2, value: '1A' },
    { id: 'terminal_phase_3_li_lic', name: 'terminal_phase_3_li_lic', data_type: 2, value: '1A' },
    { id: 'terminal_li_lic', name: 'terminal_li_lic', data_type: 2, value: 'HV & LV1' },
    { id: 'terminal_lin', name: 'terminal_lin', data_type: 2, value: 'HV & LV1' },
    { id: 'terminal_si', name: 'terminal_si', data_type: 2, value: '1A through shunt' },
    { id: 'terminal_ts_lighting', name: 'terminal_ts_lighting', data_type: 2, value: '1A terminals & tank' },
    { id: 'terminal_ts_switching', name: 'terminal_ts_switching', data_type: 2, value: '1A terminals & tank' },
    { id: 'wdg_1', name: 'wdg_1', data_type: 0, value: 'YN' },
    { id: 'wdg_2', name: 'wdg_2', data_type: 0, value: 'YN' },
    { id: 'wdg_3', name: 'wdg_3', data_type: 0, value: 'YN' },
    { id: 'p_1_wdg_1', name: 'p_1_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'p_2_wdg_1', name: 'p_2_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'p_3_wdg_1', name: 'p_3_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'p_1_wdg_2', name: 'p_1_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'p_2_wdg_2', name: 'p_2_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'p_3_wdg_2', name: 'p_3_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'p_1_wdg_3', name: 'p_1_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'p_2_wdg_3', name: 'p_2_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'p_3_wdg_3', name: 'p_3_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'll_p_1_wdg_1', name: 'll_p_1_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'll_p_2_wdg_1', name: 'll_p_2_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'll_p_3_wdg_1', name: 'll_p_3_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'll_p_1_wdg_2', name: 'll_p_1_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'll_p_2_wdg_2', name: 'll_p_2_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'll_p_3_wdg_2', name: 'll_p_3_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'll_p_1_wdg_3', name: 'll_p_1_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'll_p_2_wdg_3', name: 'll_p_2_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'll_p_3_wdg_3', name: 'll_p_3_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_1_wdg_1', name: 'dny11_p_1_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_2_wdg_1', name: 'dny11_p_2_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_3_wdg_1', name: 'dny11_p_3_wdg_1', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_1_wdg_2', name: 'dny11_p_1_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_2_wdg_2', name: 'dny11_p_2_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_3_wdg_2', name: 'dny11_p_3_wdg_2', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_1_wdg_3', name: 'dny11_p_1_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_2_wdg_3', name: 'dny11_p_2_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'dny11_p_3_wdg_3', name: 'dny11_p_3_wdg_3', data_type: 0, value: '1A1B' },
    { id: 'yna0_p_1', name: 'yna0_p_1', data_type: 0, value: '1A1B' },
    { id: 'yna0_p_2', name: 'yna0_p_2', data_type: 0, value: '1A1B' },
    { id: 'yna0_p_3', name: 'yna0_p_3', data_type: 0, value: '1A1B' },
    { id: 'wdg_1_2', name: 'wdg_1_2', data_type: 2, value: 1 },
    { id: 'wdg_1_3', name: 'wdg_1_3', data_type: 2, value: 1 },
    { id: 'wdg_2_3', name: 'wdg_2_3', data_type: 2, value: 1 },
    { id: 'wdg_1_first_rating_show', name: 'wdg_1_first_rating_show', data_type: 1, value: 126 },
    { id: 'wdg_1_second_rating_show', name: 'wdg_1_second_rating_show', data_type: 1, value: 168 },
    { id: 'wdg_1_third_rating_show', name: 'wdg_1_third_rating_show', data_type: 1, value: 210 },
    { id: 'wdg_2_first_rating_show', name: 'wdg_2_first_rating_show', data_type: 1, value: 63 },
    { id: 'wdg_2_second_rating_show', name: 'wdg_2_second_rating_show', data_type: 1, value: 84 },
    { id: 'wdg_2_third_rating_show', name: 'wdg_2_third_rating_show', data_type: 1, value: 105 },
    { id: 'wdg_3_first_rating_show', name: 'wdg_3_first_rating_show', data_type: 1, value: 63 },
    { id: 'wdg_3_second_rating_show', name: 'wdg_3_second_rating_show', data_type: 1, value: 84 },
    { id: 'wdg_3_third_rating_show', name: 'wdg_3_third_rating_show', data_type: 1, value: 105 },
    { id: 'phases_sqrt3', name: 'phases_sqrt3', data_type: 1, value: 1.73205080757 },
    { id: 'wdg_1_min_tap_string', name: 'wdg_1_min_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_1_normal_tap_string', name: 'wdg_1_normal_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_1_no_tap_string', name: 'wdg_1_no_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_1_normal_tap', name: 'wdg_1_normal_tap', data_type: 1, value: 9 },
    { id: 'wdg_1_no_tap', name: 'wdg_1_no_tap', data_type: 1, value: 17 },
    { id: 'wdg_1_max_tap', name: 'wdg_1_max_tap', data_type: 1, value: 10 },
    { id: 'wdg_1_min_tap', name: 'wdg_1_min_tap', data_type: 1, value: 10 },
    { id: 'wdg_1_max_rating', name: 'wdg_1_max_rating', data_type: 1, value: 210 },
    { id: 'wdg_1_max_rating_show', name: 'wdg_1_max_rating_show', data_type: 1, value: 210 },
    { id: 'wdg_1_first_current', name: 'wdg_1_first_current', data_type: 1, value: 330.66 },
    { id: 'wdg_1_first_phase_current', name: 'wdg_1_first_phase_current', data_type: 1, value: 330.66 },
    { id: 'wdg_1_first_phase_current_min', name: 'wdg_1_first_phase_current_min', data_type: 1, value: 330.66 },
    { id: 'wdg_1_first_phase_current_max', name: 'wdg_1_first_phase_current_max', data_type: 1, value: 330.66 },
    { id: 'wdg_1_second_current', name: 'wdg_1_second_current', data_type: 1, value: 440.89 },
    { id: 'wdg_1_second_phase_current', name: 'wdg_1_second_phase_current', data_type: 1, value: 440.89 },
    { id: 'wdg_1_second_phase_current_min', name: 'wdg_1_second_phase_current_min', data_type: 1, value: 440.89 },
    { id: 'wdg_1_second_phase_current_max', name: 'wdg_1_second_phase_current_max', data_type: 1, value: 440.89 },
    { id: 'wdg_1_third_current', name: 'wdg_1_third_current', data_type: 1, value: 551.11 },
    { id: 'wdg_1_third_phase_current', name: 'wdg_1_third_phase_current', data_type: 1, value: 551.11 },
    { id: 'wdg_1_third_phase_current_min', name: 'wdg_1_third_phase_current_min', data_type: 1, value: 551.11 },
    { id: 'wdg_1_third_phase_current_max', name: 'wdg_1_third_phase_current_max', data_type: 1, value: 551.11 },
    { id: 'wdg_1_line_current_normal', name: 'wdg_1_line_current_normal', data_type: 1, value: 551.107 },
    { id: 'wdg_1_line_current_min', name: 'wdg_1_line_current_min', data_type: 1, value: 501.007 },
    { id: 'wdg_1_line_current_max', name: 'wdg_1_line_current_max', data_type: 1, value: 612.341 },
    { id: 'wdg_1_phase_current_normal', name: 'wdg_1_phase_current_normal', data_type: 1, value: 551.107 },
    { id: 'wdg_1_phase_current_min', name: 'wdg_1_phase_current_min', data_type: 1, value: 501.007 },
    { id: 'wdg_1_phase_current_max', name: 'wdg_1_phase_current_max', data_type: 1, value: 612.341 },
    { id: 'wdg_1_line_voltage', name: 'wdg_1_line_voltage', data_type: 1, value: 220 },
    { id: 'wdg_1_line_voltage_min', name: 'wdg_1_line_voltage_min', data_type: 1, value: 242 },
    { id: 'wdg_1_line_voltage_max', name: 'wdg_1_line_voltage_max', data_type: 1, value: 198 },
    { id: 'wdg_1_phase_voltage_normal', name: 'wdg_1_phase_voltage_normal', data_type: 1, value: 127.017 },
    { id: 'wdg_1_phase_voltage_min', name: 'wdg_1_phase_voltage_min', data_type: 1, value: 139.719 },
    { id: 'wdg_1_phase_voltage_max', name: 'wdg_1_phase_voltage_max', data_type: 1, value: 114.315 },
    { id: 'wdg_1_tap_voltage_show', name: 'wdg_1_tap_voltage_show', data_type: 2, value: 1 },
    { id: 'wdg_1_tap_voltage_cal', name: 'wdg_1_tap_voltage_cal', data_type: 2, value: 1 },
    { id: 'wdg_2_min_tap_string', name: 'wdg_2_min_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_2_normal_tap_string', name: 'wdg_2_normal_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_2_no_tap_string', name: 'wdg_2_no_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_2_normal_tap', name: 'wdg_2_normal_tap', data_type: 1, value: 9 },
    { id: 'wdg_2_no_tap', name: 'wdg_2_no_tap', data_type: 1, value: 17 },
    { id: 'wdg_2_max_tap', name: 'wdg_2_max_tap', data_type: 1, value: 10 },
    { id: 'wdg_2_min_tap', name: 'wdg_2_min_tap', data_type: 1, value: 10 },
    { id: 'wdg_2_max_rating', name: 'wdg_2_max_rating', data_type: 1, value: 210 },
    { id: 'wdg_2_max_rating_show', name: 'wdg_2_max_rating_show', data_type: 1, value: 210 },
    { id: 'wdg_2_first_current', name: 'wdg_2_first_current', data_type: 1, value: 1102.21 },
    { id: 'wdg_2_first_phase_current', name: 'wdg_2_first_phase_current', data_type: 1, value: 1102.21 },
    { id: 'wdg_2_first_phase_current_min', name: 'wdg_2_first_phase_current_min', data_type: 1, value: 1102.21 },
    { id: 'wdg_2_first_phase_current_max', name: 'wdg_2_first_phase_current_max', data_type: 1, value: 1102.21 },
    { id: 'wdg_2_second_current', name: 'wdg_2_second_current', data_type: 1, value: 1469.62 },
    { id: 'wdg_2_second_phase_current', name: 'wdg_2_second_phase_current', data_type: 1, value: 1469.62 },
    { id: 'wdg_2_second_phase_current_min', name: 'wdg_2_second_phase_current_min', data_type: 1, value: 1469.62 },
    { id: 'wdg_2_second_phase_current_max', name: 'wdg_2_second_phase_current_max', data_type: 1, value: 1469.62 },
    { id: 'wdg_2_third_current', name: 'wdg_2_third_current', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_third_phase_current', name: 'wdg_2_third_phase_current', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_third_phase_current_min', name: 'wdg_2_third_phase_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_third_phase_current_max', name: 'wdg_2_third_phase_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_line_current_normal', name: 'wdg_2_line_current_normal', data_type: 1, value: 551.107 },
    { id: 'wdg_2_line_current_min', name: 'wdg_2_line_current_min', data_type: 1, value: 501.007 },
    { id: 'wdg_2_line_current_max', name: 'wdg_2_line_current_max', data_type: 1, value: 612.341 },
    { id: 'wdg_2_phase_current_normal', name: 'wdg_2_phase_current_normal', data_type: 1, value: 551.107 },
    { id: 'wdg_2_phase_current_min', name: 'wdg_2_phase_current_min', data_type: 1, value: 501.007 },
    { id: 'wdg_2_phase_current_max', name: 'wdg_2_phase_current_max', data_type: 1, value: 612.341 },
    { id: 'wdg_2_line_voltage', name: 'wdg_2_line_voltage', data_type: 1, value: 33 },
    { id: 'wdg_2_line_voltage_min', name: 'wdg_2_line_voltage_min', data_type: 1, value: 242 },
    { id: 'wdg_2_line_voltage_max', name: 'wdg_2_line_voltage_max', data_type: 1, value: 198 },
    { id: 'wdg_2_phase_voltage_normal', name: 'wdg_2_phase_voltage_normal', data_type: 1, value: 127.017 },
    { id: 'wdg_2_phase_voltage_min', name: 'wdg_2_phase_voltage_min', data_type: 1, value: 139.719 },
    { id: 'wdg_2_phase_voltage_max', name: 'wdg_2_phase_voltage_max', data_type: 1, value: 114.315 },
    { id: 'wdg_2_tap_voltage_show', name: 'wdg_2_tap_voltage_show', data_type: 2, value: 1 },
    { id: 'wdg_2_tap_voltage_cal', name: 'wdg_2_tap_voltage_cal', data_type: 2, value: 1 },
    { id: 'wdg_3_min_tap_string', name: 'wdg_3_min_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_3_normal_tap_string', name: 'wdg_3_normal_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_3_no_tap_string', name: 'wdg_3_no_tap_string', data_type: 2, value: '`NA`' },
    { id: 'wdg_3_normal_tap', name: 'wdg_3_normal_tap', data_type: 1, value: 9 },
    { id: 'wdg_3_no_tap', name: 'wdg_3_no_tap', data_type: 1, value: 17 },
    { id: 'wdg_3_max_tap', name: 'wdg_3_max_tap', data_type: 1, value: 10 },
    { id: 'wdg_3_min_tap', name: 'wdg_3_min_tap', data_type: 1, value: 10 },
    { id: 'wdg_3_max_rating', name: 'wdg_3_max_rating', data_type: 1, value: 210 },
    { id: 'wdg_3_max_rating_show', name: 'wdg_3_max_rating_show', data_type: 1, value: 210 },
    { id: 'wdg_3_first_current', name: 'wdg_3_first_current', data_type: 1, value: 1102.21 },
    { id: 'wdg_3_first_phase_current', name: 'wdg_3_first_phase_current', data_type: 1, value: 1102.21 },
    { id: 'wdg_3_first_phase_current_min', name: 'wdg_3_first_phase_current_min', data_type: 1, value: 1102.21 },
    { id: 'wdg_3_first_phase_current_max', name: 'wdg_3_first_phase_current_max', data_type: 1, value: 1102.21 },
    { id: 'wdg_3_second_current', name: 'wdg_3_second_current', data_type: 1, value: 1469.62 },
    { id: 'wdg_3_second_phase_current', name: 'wdg_3_second_phase_current', data_type: 1, value: 1469.62 },
    { id: 'wdg_3_second_phase_current_min', name: 'wdg_3_second_phase_current_min', data_type: 1, value: 1469.62 },
    { id: 'wdg_3_second_phase_current_max', name: 'wdg_3_second_phase_current_max', data_type: 1, value: 1469.62 },
    { id: 'wdg_3_third_current', name: 'wdg_3_third_current', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_third_phase_current', name: 'wdg_3_third_phase_current', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_third_phase_current_min', name: 'wdg_3_third_phase_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_third_phase_current_max', name: 'wdg_3_third_phase_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_line_current_normal', name: 'wdg_3_line_current_normal', data_type: 1, value: 551.107 },
    { id: 'wdg_3_line_current_min', name: 'wdg_3_line_current_min', data_type: 1, value: 501.007 },
    { id: 'wdg_3_line_current_max', name: 'wdg_3_line_current_max', data_type: 1, value: 612.341 },
    { id: 'wdg_3_phase_current_normal', name: 'wdg_3_phase_current_normal', data_type: 1, value: 551.107 },
    { id: 'wdg_3_phase_current_min', name: 'wdg_3_phase_current_min', data_type: 1, value: 501.007 },
    { id: 'wdg_3_phase_current_max', name: 'wdg_3_phase_current_max', data_type: 1, value: 612.341 },
    { id: 'wdg_3_line_voltage', name: 'wdg_3_line_voltage', data_type: 1, value: 33 },
    { id: 'wdg_3_line_voltage_min', name: 'wdg_3_line_voltage_min', data_type: 1, value: 242 },
    { id: 'wdg_3_line_voltage_max', name: 'wdg_3_line_voltage_max', data_type: 1, value: 198 },
    { id: 'wdg_3_phase_voltage_normal', name: 'wdg_3_phase_voltage_normal', data_type: 1, value: 127.017 },
    { id: 'wdg_3_phase_voltage_min', name: 'wdg_3_phase_voltage_min', data_type: 1, value: 139.719 },
    { id: 'wdg_3_phase_voltage_max', name: 'wdg_3_phase_voltage_max', data_type: 1, value: 114.315 },
    { id: 'wdg_3_tap_voltage_show', name: 'wdg_3_tap_voltage_show', data_type: 2, value: 1 },
    { id: 'wdg_3_tap_voltage_cal', name: 'wdg_3_tap_voltage_cal', data_type: 2, value: 1 },
    { id: 'wdg_12_calculated_ratio', name: 'wdg_12_calculated_ratio', data_type: 2, value: 1 },
    { id: 'wdg_13_calculated_ratio', name: 'wdg_13_calculated_ratio', data_type: 2, value: 1 },
    { id: 'wdg_23_calculated_ratio', name: 'wdg_23_calculated_ratio', data_type: 2, value: 1 },
    { id: 'wdg_2_max_1_line_current_normal', name: 'wdg_2_max_1_line_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_max_1_line_current_min', name: 'wdg_2_max_1_line_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_max_1_line_current_max', name: 'wdg_2_max_1_line_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_max_1_phase_current_normal', name: 'wdg_2_max_1_phase_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_max_1_phase_current_min', name: 'wdg_2_max_1_phase_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_2_max_1_phase_current_max', name: 'wdg_2_max_1_phase_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_1_line_current_normal', name: 'wdg_3_max_1_line_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_1_line_current_min', name: 'wdg_3_max_1_line_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_1_line_current_max', name: 'wdg_3_max_1_line_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_1_phase_current_normal', name: 'wdg_3_max_1_phase_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_1_phase_current_min', name: 'wdg_3_max_1_phase_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_1_phase_current_max', name: 'wdg_3_max_1_phase_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_2_line_current_normal', name: 'wdg_3_max_2_line_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_2_line_current_min', name: 'wdg_3_max_2_line_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_2_line_current_max', name: 'wdg_3_max_2_line_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_2_phase_current_normal', name: 'wdg_3_max_2_phase_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_2_phase_current_min', name: 'wdg_3_max_2_phase_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_2_phase_current_max', name: 'wdg_3_max_2_phase_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_phase_current_normal', name: 'wdg_3_max_phase_current_normal', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_phase_current_min', name: 'wdg_3_max_phase_current_min', data_type: 1, value: 1837.02 },
    { id: 'wdg_3_max_phase_current_max', name: 'wdg_3_max_phase_current_max', data_type: 1, value: 1837.02 },
    { id: 'wdg_max_rating', name: 'wdg_max_rating', data_type: 1, value: 231.0 },
    { id: 'PDF_VIEW', name: 'PDF_VIEW', data_type: 1, value: 1 },
    { id: 'lab_surface_area_lpt', name: 'lab_surface_area_lpt', data_type: 1, value: 5247.0 },
    { id: 'lab_surface_area_mpt', name: 'lab_surface_area_mpt', data_type: 1, value: 5244.0 },
    { id: 'lab_surface_area_pt', name: 'lab_surface_area_pt', data_type: 1, value: 4894.0 },
    { id: 'lab_surface_area_dt', name: 'lab_surface_area_dt', data_type: 1, value: 3824.0 },
]

export const lengthOption = [
    {
        id: 10,
        label: 10,
    },
    {
        id: 25,
        label: 25,
    },
    {
        id: 50,
        label: 50,
    },
    {
        id: 100,
        label: 100,
    },
]

export const summariesTestNameOptions = [
    'No Load Loss at 100% Excitation (at 50 Hz)',
    '% Mag Current at100% Excitation (at 50 Hz)',
    'Load Loss at 100% Normal Tap (wdg_1_marking to (wdg_2_marking + wdg_3_marking)) (at 75°C)',
    'Load Loss at 100% Normal Tap (wdg_1_marking to wdg_2_marking) (at 75°C)',
    'Load Loss at 100% Normal Tap (wdg_1_marking to wdg_3_marking) (at 75°C)',
    'Load Loss at 100% Normal Tap (wdg_2_marking to wdg_3_marking) (at 75°C)',
    'Total Loss at 50% Normal Tap (wdg_1_marking to wdg_2_marking) (at 75°C)',
    'Total Loss at 100% Normal Tap (wdg_1_marking to wdg_2_marking) (at 75°C)',
    '% Impedance at Normal Tap (wdg_1_marking to (wdg_2_marking + wdg_3_marking)) (at 75°C)',
    '% Impedance at Normal Tap (wdg_1_marking to wdg_2_marking) (at 75°C)',
    '% Impedance at Normal Tap (wdg_1_marking to wdg_3_marking) (at 75°C)',
    '% Impedance at Normal Tap (wdg_2_marking to wdg_3_marking) (at 75°C)',
    'wdg_1_marking Resistance / Ph (at 75°C)',
    'wdg_2_marking Resistance / Ph (at 75°C)',
    'wdg_3_marking Resistance / Ph (at 75°C)',
    'Top Oil temp rise in °C',
    'wdg_1_marking temp rise in °C',
    'wdg_2_marking temp rise in °C',
    'wdg_3_marking temp rise in °C',
]

export const summariesUnitsOptions = ['Watts', 'kWatts', '%', 'Ohms', '⁰C']

export const summariesToleranceOptions = [
    'MAX',
    'FLRC',
    '± IS TOLS',
    '.+ IS Tols',
    '.+Ve 7.5% IS Tols',
    '.-Ve 7.5% IS Tols',
    '.+Ve 10% IS Tols',
    '.-Ve 10% IS Tols',
    '± IEC Tols',
    '.+ IEC Tols',
    '.+Ve 7.5% IEC Tols',
    '.-Ve 7.5% IEC Tols',
    '.+Ve 10% IEC Tols',
    '.-Ve 10% IEC Tols',
    '± IEEE Tols',
    '.+Ve IEEE Tols',
    '.-Ve IEEE Tols',
]

export const DefaultImage = {
    name: null,
    image: '/file/images/default.png?w=300&h=300',
    condition: true,
}
